import React from 'react';
import { observer } from 'mobx-react';
import { observable, action, makeObservable } from 'mobx';
import { Alert, Typography, Box, Modal, Button } from '@mui/material';


class ActionDialogState {
    component = null;  // React component
    state = null;  // MobX observable

    constructor() {
        makeObservable(this, {
            component: observable,
            state: observable,
            //
            setComponent: action,
            close: action,
        });
    }

    setComponent(component, state) {
        this.component = component;
        this.state = state;
    }
    close() {
        this.component = null;
        this.state = null;
    }
}


export const actionDialogState = new ActionDialogState();


export const ActionDialog = () => {
    // Bind to the static state
    return <_ActionDialog state={actionDialogState} />;
};


const _ActionDialog = observer(({ state }) => {
    const handleClose = () => {
        state.close();
    }

    return (
        <Modal
            open={state.component !== null}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={{
                position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                maxHeight: '90vh',
                maxWidth: { xs: '95vw', sm: '90vw', md: '600px' },
                width: { xs: '95vw', sm: '90vw' },
                backgroundColor: 'white',
                padding: 3,
                borderRadius: 3,
                display: 'flex',
                flexDirection: 'column',
                outline: 'none',
            }}>
                {state.component !== null
                    ? <state.component state={state.state} onDone={() => { state.close(); }} />
                    : <Alert severity="error">UI error: No component selected</Alert>
                }
                <Button
                    sx={{ mt: 2 }}
                    onClick={handleClose}
                >Отмена</Button>
            </Box>
        </Modal>
    );
});
